var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPolyshape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5228 12.9395H13.8653C13.5526 12.9395 13.2991 13.193 13.2991 13.5057V19.1632C13.2991 19.4759 13.5526 19.7295 13.8653 19.7295H19.5228C19.8356 19.7295 20.0891 19.4759 20.0891 19.1632V13.5057C20.0891 13.193 19.8356 12.9395 19.5228 12.9395Z",
    fill: "#7666E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08294 12.784L3.93631 15.9306C3.71274 16.1542 3.71274 16.5167 3.93631 16.7403L7.08294 19.8869C7.30651 20.1105 7.669 20.1105 7.89257 19.8869L11.0392 16.7403C11.2628 16.5167 11.2628 16.1542 11.0392 15.9306L7.89257 12.784C7.669 12.5604 7.30651 12.5604 7.08294 12.784Z",
    fill: "#15BC80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44456 10.7363C9.31957 10.7363 10.8396 9.2163 10.8396 7.34129C10.8396 5.46628 9.31957 3.94629 7.44456 3.94629C5.56955 3.94629 4.04956 5.46628 4.04956 7.34129C4.04956 9.2163 5.56955 10.7363 7.44456 10.7363Z",
    fill: "#FFC02A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2044 4.48625L13.2344 9.63C13.0169 10.0075 13.2894 10.4788 13.7244 10.4788H19.6632C20.0982 10.4788 20.3707 10.0075 20.1532 9.63L17.1832 4.48625C16.9657 4.10875 16.4207 4.10875 16.2032 4.48625H16.2044Z",
    fill: "#E8464F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolyshape);
export default __webpack_public_path__ + "static/media/icon_polyshape.4e2635ee.svg";
export { ForwardRef as ReactComponent };